import ElementUI from 'element-ui'
import Vue from 'vue'

export default () => {
  Vue.prototype.$message = function(msg) {
    ElementUI.Message(msg)
  }

  const types = ['success', 'warning', 'info', 'error']
  types.forEach(item => {
    Vue.prototype.$message[item] = function(msg) {
      return ElementUI.Message[item]({
        message: msg,
        duration: 1500,
        offset: 100
      })
    }
  })
}
